export const arrayToUrlQueryString = ({ queryParam, values }) => {
  if (values?.length > 0) {
    return values.reduce(
      (acc, val) => `${acc}&${queryParam}[]=${val ?? ""}`,
      ""
    )
  } else {
    return ""
  }
}

export const buildQueryString = (params = {}) => {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") return

    if (Array.isArray(value)) {
      value.forEach((v) => searchParams.append(`${key}[]`, v))
    } else {
      searchParams.append(key, value)
    }
  })

  const qs = searchParams.toString()
  return qs ? `?${qs}` : ""
}
